export const contactSupport = {
  support_title_message: "Contact us and we will solve it together!",
  support_message: "If you need help or have any questions, our team is ready to help you.",
  support_modal_email: "Email",
};
